import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../../sessionStorage';
import ProductCarriers from '../../../Helpers/Data/Products/TermInsurance/ProductCarriers';

import "./CarrierLogos.scss";

export default function CarrierLogos() {
  const { productCarrierData, productCategory } = ProductCarriers();

  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  const accountCarriers = accountObj && accountObj.accountCarriers;
  const accountCarriersList = accountCarriers.sort((a, b) => a.displayOrder - b.displayOrder).filter((item) => item.productCategory === productCategory);
  const carriers = (accountCarriersList && accountCarriersList.length !== 0) ? accountCarriersList : productCarrierData;

  return (
    <Row className="carrier-logo-wrapper">
      <Carousel carriers={carriers} />
    </Row>);
}

export function Carousel({carriers}) {
  const carrierLogoContainerRef = useRef(null);
  const carrierLogoTrackRef = useRef(null);
  const [removeDuplicates, setRemoveDuplicates] = useState(false);
  const [initialFixedTrackWidth, setInitialFixedTrackWidth] = useState(null);

  useEffect(() => {
    const setIniniteCarousel = () => {
      const track = carrierLogoTrackRef.current;
      const container = carrierLogoContainerRef.current;
      const scrollSpeedInSeconds = track.scrollWidth / 40;

      if (track.offsetWidth > container.offsetWidth) {
        const carrierContent = Array.from(track.children);
        if (carrierContent.length <= carriers.length) {
          carrierContent.forEach((item) => {
            const duplicateItem = item.cloneNode(true);
            duplicateItem.setAttribute("aria-hidden", true);
            track.appendChild(duplicateItem);
          });
          container.style.justifyContent = "start";
        }
  
        if (!track.hasAttribute("style") && scrollSpeedInSeconds) {
          if (!container.classList.contains("scrollable")) {
            container.classList.add("scrollable");
          }
          
          track.style.animationDuration = `${scrollSpeedInSeconds}s`;
        }
      } else {
        setRemoveDuplicates(true);
        setInitialFixedTrackWidth(track.offsetWidth);
        container.style.justifyContent = "center";
        track.removeAttribute("style");
      }

      if (initialFixedTrackWidth < container.offsetWidth && removeDuplicates) {
        const carrierContent = Array.from(track.children);

        if (carrierContent.length !== 0) {
          carrierContent.forEach((item) => {
            if (item.hasAttribute("aria-hidden")) {
              item.remove();
            }
          });
        }

        if (container.classList.contains("scrollable")) {
          container.classList.remove("scrollable");
        }

        container.style.justifyContent = "center";
        track.removeAttribute("style");
      }
    };
    
    window.addEventListener("resize", setIniniteCarousel);
    setIniniteCarousel();

    return () => window.removeEventListener("resize", setIniniteCarousel);
    
  },[removeDuplicates, initialFixedTrackWidth]);

  return (
    <div className="carrier-logo-container" ref={carrierLogoContainerRef}>
      <ul className="logo-track"
        ref={carrierLogoTrackRef}>
        {carriers.map((logo, i) => {
          return (
            <CarouselItem carrier={logo} key={`logo${i}`} />
          );
        })}
      </ul>
    </div>);
}

export function CarouselItem({carrier}) {
  return (
    <li className="logo-container">
      <img src={carrier.logoLink} alt={`${carrier.carrierName ? carrier.carrierName : "Carrier"} Logo`} />
    </li>);
}

Carousel.propTypes = {
  carriers: PropTypes.any,
}

CarouselItem.propTypes = {
  carrier: PropTypes.any,
}